// URL-locale helpers. Локаль кодируется префиксом пути для не-дефолтных языков:
//   ru (default) → /dashboard          (без префикса)
//   en           → /en/dashboard
//
// BrowserRouter получает basename из локали, поэтому внутренние Route-пути остаются
// без префикса (/dashboard), а в адресной строке отображается /en/dashboard.
import { SUPPORTED_CODES, DEFAULT_LANGUAGE } from './index'

// Определяет локаль из пути (первый сегмент). Не-язык → дефолт.
export function localeFromPath(pathname: string = window.location.pathname): string {
  const seg = pathname.split('/')[1]
  return SUPPORTED_CODES.includes(seg) ? seg : DEFAULT_LANGUAGE
}

// basename для BrowserRouter: '/' для дефолта, '/<code>' для остальных.
export function basenameForLocale(locale: string): string {
  return locale === DEFAULT_LANGUAGE ? '/' : `/${locale}`
}

// Строит URL текущей страницы под другой локалью (для переключателя языка).
// Сохраняет путь и query, меняет только префикс локали.
export function switchLanguagePath(targetLocale: string): string {
  const current = localeFromPath()
  let rest = window.location.pathname
  if (current !== DEFAULT_LANGUAGE) {
    rest = rest.replace(new RegExp(`^/${current}(?=/|$)`), '')
  }
  if (rest === '') rest = '/'
  const prefix = targetLocale === DEFAULT_LANGUAGE ? '' : `/${targetLocale}`
  return prefix + rest + window.location.search
}
